import store from '@/store/store'

import { apiClient } from '@/services/ApiClient.js'
import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getFarmers(query) {
    return RetailerApiClient.get('farmers', {
      params: query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFarmer(id) {
    return RetailerApiClient.get('farmers/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFarmersHaveLimit() {
    return RetailerApiClient.get('farmers/have-limit')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getInfo(tckn) {
    return RetailerApiClient.get('farmers/info/' + tckn)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  validate(id, parameters) {
    return RetailerApiClient.post('farmers/' + id + '/validate', parameters)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getStatistics(id) {
    return RetailerApiClient.get('farmers/' + id + '/statistics')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  referralCode(referralCode) {
    return RetailerApiClient.get('farmers/referral-code/' + referralCode)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  validatePhone(tckn, phone) {
    return RetailerApiClient.post('farmers/validate-phone', {
      phone: phone,
      tckn: tckn
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBusinessNumber(tckn) {
    return RetailerApiClient.get('farmers/business-number', {
      params: { tckn: tckn }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateBusinessNumber(farmerId, businessNumber) {
    return RetailerApiClient.patch('farmers/' + farmerId + '/business-number', {
      business_number: businessNumber
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateMernisInformation(farmerId, farmerData) {
    return RetailerApiClient.patch('farmers/' + farmerId + '/mernis-information', farmerData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateFarmer(farmerId, farmerData) {
    return RetailerApiClient.patch('farmers/' + farmerId, farmerData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFarmerByTckn(tckn) {
    return RetailerApiClient.get('farmers/get-farmer-by-tckn', {
      params: { tckn: tckn }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  mernisValidation(farmer) {
    return RetailerApiClient.post('farmers/mernis-validation', farmer)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  mernisValidationWithFarmer(farmer) {
    return RetailerApiClient.post('farmers/mernis-validation-with-farmer', farmer)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendVerifyPhoneOTPCode(tckn, phone, application_id = null) {
    return RetailerApiClient.post('farmers/verify-phone', {
      tckn,
      phone,
      application_id
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkPolicyAcceptance(
    tckn,
    phone,
    send_otp,
    send_gdpr_consent_link,
    application_id = null,
    sales_channel_id = null,
    tarfin_company_type_for_ro = null,
    is_resend = false
  ) {
    const data = {
      tckn,
      phone,
      send_otp,
      send_gdpr_consent_link,
      tarfin_company_type_for_ro,
      is_resend
    }

    if (application_id) {
      data.application_id = application_id
    }

    if (sales_channel_id) {
      data.sales_channel_id = sales_channel_id
    }

    return RetailerApiClient.post('farmers/check-policy-acceptance', data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkFarmerExists(nin) {
    return RetailerApiClient.get('farmers/' + nin + '/exists')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  verifyPhoneOTPCode(tckn, code, phone) {
    return RetailerApiClient.post('farmers/verify-otp-code', {
      tckn,
      code,
      phone
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  verifyPolicyAcceptance(tckn, code) {
    return RetailerApiClient.post('farmers/verify-policy-acceptance', {
      tckn,
      code
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkGuarantorPermit(tckn, cash_price) {
    return RetailerApiClient.post('farmers/check-guarantor-permit', {
      tckn,
      cash_price
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  verifyConfirmationCodeAcceptance(phone, otp_type, code, application_id) {
    return RetailerApiClient.post('applications/' + application_id + '/verify-otp', {
      phone,
      otp_type,
      code
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  isGdprConsentLinkExist(gdpr_consent_link_hash) {
    return apiClient
      .post('/general/farmers/is-gdpr-consent-link-exist', { gdpr_consent_link_hash })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  approveGdprConsentLinkAndCreateOtp(gdpr_consent_link_hash) {
    return apiClient
      .post('/general/farmers/approve-gdpr-consent-link-and-create-otp', { gdpr_consent_link_hash })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateGdprConsentLinkToOpened(gdpr_consent_link_hash) {
    return apiClient
      .post('/general/farmers/update-gdpr-consent-link-to-opened', { gdpr_consent_link_hash })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadGdprDocument(tckn, file) {
    let formData = new FormData()
    formData.append('document', file.file)
    formData.append('tckn', tckn)

    return apiClient
      .postForm('/general/farmers/upload-gdpr-document', formData, {
        onUploadProgress: progressEvent => {
          if (progressEvent.total !== null) {
            let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            store.dispatch('retailerFarmer/setUploadGdprDocumentPercentage', percentage)
          }
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getQrCodeForGdprDocumentUpload(tckn, phone) {
    return RetailerApiClient.get('farmers/get-qr-code-gdpr-document-upload/' + tckn + '?phone=' + phone)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewGdprDocument(id, contentType) {
    return RetailerApiClient.get('farmers/view-gdpr-document/' + id, { responseType: 'arraybuffer' })
      .then(response => {
        let blob = new Blob([response], { type: contentType })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  checkGdprConsentDocument(tckn) {
    return RetailerApiClient.get('farmers/check-gdpr-document/' + tckn, {
      validateStatus: function (status) {
        return true
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkReferralCode(code) {
    return RetailerApiClient.post('farmers/check-referral-code', {
      referral_code: code
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPreApprovedLimit(tckn) {
    return RetailerApiClient.get('farmers/get-pre-approved-limit', {
      params: { tckn: tckn }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  cancelPendingUpdateFarmerActions(farmerId) {
    return RetailerApiClient.patch('farmers/' + farmerId + '/cancel-pending-update-actions')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
